import { Box } from "@mui/material";
import get from "lodash/get";
import { useRecordContext } from "react-admin";
import { YamlView } from "./YamlView";

export const YamlField = ({ source, ...props }) => {
  const record = useRecordContext();
  if (!record) return null;

  const data = get(record, source);

  return (
    <Box className="YamlField" {...props}>
      <YamlView data={data} />
    </Box>
  );
};
